import React, { useEffect, useState } from "react";
import { Box, TextField, IconButton, Typography } from "@mui/material";
import { Check as CheckIcon, Edit as EditIcon } from "@mui/icons-material";

interface EditableTextFieldProps {
  value: string;
  onSave: (newValue: string) => void;
  isLoading: boolean;
  /** the pencil shows only while hovering the field */
  showEditOnHover?: boolean;
  bold?: boolean;
  /** overrides the h5 size (e.g. "1.75rem") */
  fontSize?: string;
}
const EditableTextField: React.FC<EditableTextFieldProps> = ({
  value,
  onSave,
  isLoading,
  showEditOnHover = false,
  bold = false,
  fontSize,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    if (!isEditing) {
      setLocalValue(value);
    }
  }, [value, isEditing]);

  const handleSaveClick = () => {
    if (localValue !== value) {
      onSave(localValue); // מחזיר את הערך החדש להורה
    }
    setIsEditing(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        // on hover only - and outside the flow, so the value stays centered where it is placed
        ...(showEditOnHover && {
          position: "relative",
          "& .editable-edit": { opacity: 0, transition: "opacity .15s", position: "absolute", insetInlineStart: "100%" },
          "&:hover .editable-edit": { opacity: 1 },
        }),
      }}
    >
      {isEditing ? (
        <>
          <TextField
            variant="outlined"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            size="small"
          />
          <IconButton onClick={handleSaveClick} disabled={isLoading}>
            <CheckIcon />
          </IconButton>
        </>
      ) : (
        <>
          <Typography variant="h5" fontWeight={bold ? 700 : undefined} fontSize={fontSize}>{value}</Typography>
          <IconButton className="editable-edit" onClick={() => setIsEditing(true)}>
            <EditIcon sx={{ color: "gray" }} />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default EditableTextField;